import React from "react";
import ReadArticlePage from "../Component/ReadArticlePage.jsx";
import { getArticle } from "../api.js"
import { useState } from "react";
import { useEffect } from "react";

const ReadArticlePageContainer = () => {

    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    const setReload = () => {
        setLoading(true);
    }

    useEffect(()=> {
        getArticle()
            .then((res)=> {
                setArticles(res);
                setLoading(false);
            })
            .catch((err)=>{
                console.log(err);
            });
    }, [loading]);

    return (
        <ReadArticlePage articles={articles} loading={loading} setReload={setReload}/>
    )
}

export default ReadArticlePageContainer;